<template>
  <ReportSimpleDataTable
    :urls="urls"
    :mandatory-filter="[
      {
        name: 'country',
        title: 'Country',
        valueFieldName: '',
      },
    ]"
  />
</template>

<script>
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import ReportSimpleDataTable from "@/own/components/reports/ReportSimpleDataTable.vue";
export default {
  name: "CountryList",
  components: { ReportSimpleDataTable },
  data: () => ({
    urls: {
      data_url: "/reports/countryList",
      show_url: "/reports/countryList/show",
    },
  }),
  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
  },
};
</script>
